import { withNamespaces } from "react-i18next";
import { Card, CardHeader, Col, ListGroup, ListGroupItem, Row } from "reactstrap";
import { ResidualRisksRates } from 'src/common/constants'

const ResidualRiskDetail = ({ t, risk, matrixQuery }) => {
    return (
        <Card
            outline
            body
            style={{ width: 'auto' }}
            className={`border border-primary rounded ${risk && !risk.residualRisk?.result ? 'd-none' : ''}`}
        >
            <CardHeader>
                {t('Residual Risk')}
            </CardHeader>

            <ListGroup flush style={{ borderRadius: '0' }}>
                {/* Damage */}
                <ListGroupItem className='border-bottom border-primary'>
                    <Row>
                        <Col>
                            <p style={{ marginBottom: 0, lineHeight: '26px' }}>
                                {t('Damage')}
                            </p>
                        </Col>
                        <Col>
                            {!matrixQuery.isFetching && risk ? (
                                <span className='p-2' style={{ marginBottom: 0, display: 'block' }}>
                                    {matrixQuery?.data?.currency + " " + Number(
                                        risk.residualRisk?.damage
                                    ).toLocaleString(
                                        localStorage.getItem("i18nextLng")
                                    )}
                                </span>
                            ) : (
                                <div className='dt-field dt-skeleton' style={{ height: 27 }}></div>
                            )}
                        </Col>
                    </Row>
                </ListGroupItem>

                {/* Likelihood */}
                <ListGroupItem className='border-bottom border-primary '>
                    <Row>
                        <Col>
                            <p style={{ marginBottom: 0, lineHeight: '36px' }}>
                                {t('Likelihood')}
                            </p>
                        </Col>
                        <Col>
                            {risk ? (
                                <span className='p-2' style={{ marginBottom: 0, display: 'block' }}>
                                    {t(risk.residualRisk?.likelihood)}
                                </span>
                            ) : (
                                <div className='dt-field dt-skeleton dt-select-list'></div>
                            )}
                        </Col>
                    </Row>
                </ListGroupItem>

                {/* risk rating */}
                <ListGroupItem className='border-bottom border-primary border-0'>
                    <Row>
                        <Col>
                            <p style={{ marginBottom: 0, lineHeight: '27px' }}>{t('Risk rating')}</p>
                        </Col>
                        <Col>
                            {risk ? (
                                <span
                                    className='badge text-white rounded p-2'
                                    style={{
                                        marginBottom: 0,
                                        display: 'block',
                                        fontWeight: 'bold',
                                        backgroundColor: `${ResidualRisksRates[risk.residualRisk?.result]?.color}`,
                                    }}
                                >
                                    {t(ResidualRisksRates[risk.residualRisk?.result]?.title)}
                                </span>
                            ) : (
                                <div className='dt-field dt-skeleton' style={{ height: 26 }}></div>
                            )}
                        </Col>
                    </Row>
                </ListGroupItem>
            </ListGroup>
        </Card>
    )
}

export default withNamespaces()(
    ResidualRiskDetail
);